/**
 * Created by shubham on 17/5/18.
 */

import { Component } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpService } from '../shared/services/http.service'
import { MdDialog } from '@angular/material';
import { DialogComponent } from '../dialog/dialog.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import {TranslateService} from 'ng2-translate';

@Component({
    template: require('./forgotPassword.component.html')
})

export class ForgotPasswordComponent {
    data: any = [];
    dialogRef;
    id: any;
    languageId: any;
    ForgetPasswordForm: FormGroup;
    ForgetPasswordFormDetails: any;

    constructor(private router: Router, private route: ActivatedRoute, private httpService: HttpService,private sessionHandler:SessionHandler,
                public dialog: MdDialog,  private translate: TranslateService,  private formBuilder: FormBuilder, private commonService: CommonService) {
    }

    buildForm() {
        this.ForgetPasswordForm = this.formBuilder.group({
            userId_WPASS: this.formBuilder.control(null, [Validators.required]),
        });
        this.ForgetPasswordForm.valueChanges.subscribe(data => {
            this.ForgetPasswordFormDetails = this.ForgetPasswordForm.getRawValue();
        });
    }

    public forgetPassword(){
        this.httpService.postRequest(this.ForgetPasswordFormDetails,'userOperationsApi/v1/forgotPassword').subscribe(
            res => { this.saveResponse(res); },
            err => {
                this.httpService.onEnd();
            }
        );
    }

    public saveResponse(res){
        if(res){
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'after_reset_password_notify';
            this.dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/login');
            });
        }
        this.httpService.onEnd();
    }

    ngOnInit(): void {
        this.buildForm();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/forgot-password/forgotPassword.component.ts